import React from 'react';
import { useLocation } from 'react-router-dom';
import Navigation from './Navigation';

/**
 * MainLayout Component
 * Provides the main layout structure for authenticated pages
 * Includes navigation bar and content area
 */
const MainLayout = ({ children }) => {
  const location = useLocation();

  // Don't show navigation on auth pages
  const isAuthPage = ['/login', '/register', '/signup', '/verify-otp', '/forgot-password', '/reset-password-otp', '/verify-email', '/reset-password'].includes(location.pathname);

  // Feed, My Posts, Jobs, and Profile pages need full viewport without padding/constraints for viewport optimization
  const isFullWidthPage = location.pathname.startsWith('/feed') || location.pathname.startsWith('/myposts') || location.pathname.startsWith('/jobs') || location.pathname.startsWith('/in/');

  if (isAuthPage) {
    return <>{children}</>;
  }

  if (isFullWidthPage) {
    return (
      <div className="h-screen bg-gray-50 flex flex-col overflow-hidden">
        <Navigation />
        <main className="w-full flex-1 overflow-y-auto overflow-x-hidden">
          {children}
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>
    </div>
  );
};

export default MainLayout;
